import { allTvSeries } from '@/mocks/tvSeries';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import StatsBanner from './components/StatsBanner';
import TvGrid from './components/TvGrid';
import WhyUs from './components/WhyUs';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  const hotItems = allTvSeries
    .filter((item) => item.isHot)
    .slice(0, 12);

  const newItems = allTvSeries
    .filter((item) => item.isNew)
    .slice(0, 12);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '成全影视',
    url: 'https://alu-expo-1.cn/',
    description: '成全影视提供电视剧全集播放，不缓冲看剧免费在线观看，全集免费电视剧流畅追剧完整版，热门电视剧大全免费高清在线免VIP观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://alu-expo-1.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '成全影视',
    url: 'https://alu-expo-1.cn/',
    description: '成全影视提供电视剧全集播放，不缓冲看剧免费在线观看，全集免费电视剧流畅追剧完整版，热门电视剧大全免费高清在线免VIP观看。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@alu-expo-1.cn',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <title>成全影视 - 电视剧全集播放不缓冲看剧免费在线观看 | 全集免费电视剧流畅追剧完整版</title>
      <meta name="description" content="成全影视提供电视剧全集播放，不缓冲看剧免费在线观看，全集免费电视剧流畅追剧完整版，热门电视剧大全免费高清在线免VIP观看。涵盖国产剧、韩剧、美剧、日剧等分类，每天更新最新剧集。" />
      <meta name="keywords" content="成全影视,电视剧全集播放,不缓冲看剧,免费在线观看,全集免费电视剧,流畅追剧,电视剧完整版,热门电视剧大全,高清免费,免VIP,看剧,追剧" />
      <link rel="canonical" href="https://alu-expo-1.cn/" />
      <meta property="og:title" content="成全影视 - 电视剧全集播放不缓冲看剧免费在线观看" />
      <meta property="og:description" content="成全影视提供电视剧全集播放，不缓冲看剧免费在线观看，全集免费电视剧流畅追剧完整版，热门电视剧大全免费高清在线免VIP观看。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://alu-expo-1.cn/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="成全影视 - 电视剧全集播放不缓冲看剧免费在线观看" />
      <meta name="twitter:description" content="成全影视提供电视剧全集播放，不缓冲看剧免费在线观看，全集免费电视剧流畅追剧完整版，热门电视剧大全免费高清在线免VIP观看。" />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <main>
        <HeroSection />
        <CategoryNav />
        <StatsBanner />

        <TvGrid
          title="热门推荐"
          items={hotItems}
          viewAllLink="/category/dianshiju"
          accent
        />

        <WhyUs />

        <TvGrid
          title="最新更新"
          items={newItems}
          viewAllLink="/category/dianshiju"
        />

        <ArticleSection />
      </main>
    </>
  );
}